module.exports = __webpack_public_path__ + "img/header-engagementRingsRosegold@2x.a93c911.webp";